import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import uiDux from 'src/redux/ui/';
import appDux from 'src/redux/app/';
import constants from 'src/constants';
import ExtendedSidebar from 'src/components/Sidebar/ExtendedSidebar';
import utils from 'src/utils';
import ExtendedSidebarHeader from './Header';
import VariationGroupSelector from './VariationGroupSelector';
import MenuItem from './MenuItem';
import SelectionUnavailable from './SelectionUnavailable';
import { ExtendedSidebarContentContainer, SelectorContent } from './styled';

const { showInDesignExtendedSidebar } = utils.designSidebar;

const mapStateToProps = (state) => ({
  activeEditingAttribute: appDux.selectors.getActiveEditingAttribute(state),
  extendedSidebarData: appDux.selectors.getExtendedSidebarData(state),
  activeEditingAttributePropertyId: appDux.selectors.getActiveEditingAttributePropertyId(
    state,
  ),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      handleAttributeSelectionClick:
        uiDux.actions.handleAttributeSelectionClick,
      closeExtendedSidebar: uiDux.actions.closeExtendedSidebar,
    },

    dispatch,
  );

export class DesignExtendedSidebar extends PureComponent {
  static propTypes = {
    handleAttributeSelectionClick: PropTypes.func.isRequired,
    activeEditingAttribute: PropTypes.object.isRequired,
    extendedSidebarData: PropTypes.object.isRequired,
    activeEditingAttributePropertyId: PropTypes.string,
    closeExtendedSidebar: PropTypes.func.isRequired,
  };

  render() {
    const {
      extendedSidebarData: { items = [], shouldShowVariationGroups },
      handleAttributeSelectionClick,
      activeEditingAttributePropertyId,
      activeEditingAttribute,
    } = this.props;

    const shouldRenderItems = !!items.length && !shouldShowVariationGroups;
    const isEditingProduct =
      activeEditingAttribute.property ===
      constants.app.PRODUCT_ATTRIBUTE_PROPERTY;
    const lastItemIndex = items.length - 1;

    return (
      <ExtendedSidebar
        category={activeEditingAttribute.property}
        render={({ closeExtendedSidebar }) => (
          <ExtendedSidebarContentContainer>
            <ExtendedSidebarHeader />
            <SelectorContent>
              {/* If variation groups are present, VariationGroupSelector will
              render the groups and variations */}
              {shouldShowVariationGroups && <VariationGroupSelector />}

              {/* If no variation groups, render the variation items */}
              {shouldRenderItems &&
                items
                  .filter((item) => showInDesignExtendedSidebar(item))
                  .map((item, i) => {
                    return (
                      <MenuItem
                        key={item.id}
                        {...item}
                        isEditingProduct={isEditingProduct}
                        isSelected={
                          activeEditingAttributePropertyId === item.id
                        }
                        handleClick={() => handleAttributeSelectionClick(item)}
                        isLastItem={lastItemIndex === i}
                      />
                    );
                  })}

              {/* If no variation items or variation groups, render selection unavailable */}
              {!(items.length || shouldShowVariationGroups) && (
                <SelectionUnavailable
                  attributeName={activeEditingAttribute.property}
                />
              )}
            </SelectorContent>
          </ExtendedSidebarContentContainer>
        )}
      />
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DesignExtendedSidebar);
